import React from 'react';
import { View, Image, Text, Platform, TouchableOpacity, Dimensions } from 'react-native';
import styles from './styles/styles';
import { getResponsiveStyle, widthInPercentage } from '../../utils/appUtils';
import TopnavCommon from '../InternalComponents/TopnavCommon';
import AsyncStorage from '@react-native-community/async-storage';
import { AUTH, DeActivateToken } from '../../network/request/apirequests.js';
import ApiTag from '../../network/request/apiTags';
import {
  ALL_CONSTANTS
} from '../../constants/displayConstants';

const Header = (props) => {
  const {
    children,
    measure,
    notrequired,
    heading,
    time,
    isSearch,
    user,
    showip,
    identification,
    blurValue,
    headingWithoutBold,
    extraStyle,
    isButton,
    placeholder,
    subHeading,
    headerFlag,
    disabled,
    dropDownOpen,
    userAddress,
    userIp,
    Dontshow_Searchoption,
    noSearch
  } = props;
  const handlePick = (data) => {
    props.backBlur(data);
  }
  const navigateHomescreen = async () => {
    if (Platform.OS == 'web') {
      const pathName = window.location.pathname;
      const domainName = window.location.origin;

      const path = [
        ALL_CONSTANTS.PROFILE_PATH,
        ALL_CONSTANTS.ACCOUNT_PATH,
        ALL_CONSTANTS.CREDIT_CARD_PATH,
        ALL_CONSTANTS.LOAN_PATH,
        ALL_CONSTANTS.DEPOSITS_PATH,
        ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH,
        ALL_CONSTANTS.FOREX_PATH,
        ALL_CONSTANTS.DUE_PATH
      ];

      let updatedPath = pathName.substr(0, pathName.lastIndexOf('/'));
      if (path.includes(updatedPath)) {
        window.location.href = `${domainName}${updatedPath}`;
        return;
      } else {
        window.location.href = `${domainName}/servicing/index.html`;
      }
    } else {
      window.location.href = `${domainName}/servicing/index.html`;
      //props.navigation.navigate('HomePage');
    }
  };

  onGoBack = () => {
    props.onGoBack(true);
  }
  async function removeToken() {
    let userToken;
    if (Platform.OS === 'web') {
      userToken = sessionStorage.getItem('token');
    } else {
      userToken = await AsyncStorage.getItem('token');
    }
    var fieldData = {
      "token": userToken,
    };
    this.makeAPICall(
      DeActivateToken(fieldData, AUTH),
      onDataReceived,
      this.onError
    );
  }

  const onDataReceived = response => {
    this.setState({ loading: false });
    var that = this;
    if (ApiTag.DEACTIVATE_TOKEN == response.tag) {
      if (response.data.status === 200) {
      }
    }
  };
  return (
    <View
      style={
        Platform.OS === 'web'
          ? [
            styles.backgroundMainview, {
             width: '100%',
            },
            styles[getResponsiveStyle('backgroundMainview', measure)]
          ]
          : [
            styles.backgroundMainviewMobile,
            styles[getResponsiveStyle('backgroundMainviewMobile', measure)]
          ]
      }
    >
      {measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' ? (
        headerFlag ? (<View style={styles.nav}><View
          style={[
            styles.TopnavMainview,
            { zIndex: 7, height: dropDownOpen ? 120 : 60 },
            styles[getResponsiveStyle('TopnavMainview', measure)]
          ]}
        >
          <View
            style={[
              styles.TopnavMainview2,
              styles[getResponsiveStyle('TopnavMainview2', measure)]
            ]}
          >
            <View
              style={[
                styles.TopnavMainview3,
                styles[getResponsiveStyle('TopnavMainview3', measure)]
              ]}
            >
              <TouchableOpacity>
                <Image
                  style={[
                    styles.TopnavMobileLogostyle,
                    styles[getResponsiveStyle('TopnavMobileLogostyle', measure)]
                  ]}
                  resizeMode='contain'
                  source={require('../../assets/images/icici-bank-logo.svg')}
                />
              </TouchableOpacity>
            </View>
            <View
              style={[
                styles.TopnavMobileLogoView,
                styles[getResponsiveStyle('TopnavMobileLogoView', measure)]
              ]}
            />
            {/* <button
              type='button'
              class='navbar-toggle collapsed visible-xs'
              data-toggle='collapse'
              data-target='#bs-example-navbar-collapse-1'
              style={{
                height: 35,
                top: 10,
                backgroundColor: 'transparent',
                border: 'none'
              }}
            >
              <Image
                source={require('../../assets/images/insta_dropdown.png')}
                style={{ width: 25, height: 14 }}
              />
              {/* <span class="sr-only">Toggle navigation</span> */}
            {/* <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span> */}
            {/* </button>  */}
            <View
              style={{ flexDirection: 'row' }}>
              <View
                style={[
                  styles.TopNavDropdownMainViewHeader,
                  { flexDirection: 'row' },
                  styles[getResponsiveStyle('TopNavDropdownMainViewHeader', measure)]
                ]}
              >
                <TouchableOpacity
                  onPress={props.toggle ? props.toggle() : null}
                >
                  <Image
                    style={[
                      styles.TopNavDropdownImgViewHeader,
                      styles[getResponsiveStyle('TopNavDropdownImgViewHeader', measure)]
                    ]}
                    source={require('../../assets/images/dropdownVerification.png')}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
          {dropDownOpen ?
            // <View
            //   style={[
            //     styles.TopnavMobileIPLOCATIONdettopnavmobHeader,
            //     styles[
            //     getResponsiveStyle('TopnavMobileIPLOCATIONdettopnavmobHeader', measure)
            //     ]
            //   ]}
            // >
            //   <View>
            //     <Text
            //       style={[
            //         styles.TopnavMobileIPTextHeader,
            //         styles[
            //         getResponsiveStyle('TopnavMobileIPTextHeader', measure)
            //         ]
            //       ]}
            //     >
            //       IP: {props.userIp}
            //     </Text>
            //   </View>
            //   <View style={{ marginTop: 5 }}>
            //     <Text
            //       style={[
            //         styles.TopnavMobileIPText,
            //         styles[
            //         getResponsiveStyle('TopnavMobileIPText', measure)
            //         ]
            //       ]}
            //     >
            //       Location: {props.userAddress}
            //     </Text>
            //   </View>
            // </View>
            showip ?
              <View
                style={[
                  styles.TopnavMobileIPLOCATIONdettopnavmobHeader,
                  styles[
                  getResponsiveStyle('TopnavMobileIPLOCATIONdettopnavmobHeader', measure)
                  ]
                ]}
              >
                <View
                  style={[
                    styles.newTopNavImage2Mainview,
                    {
                      marginLeft: props.Dontshow_Searchoption ? props.Dontshow_Searchoption ? '55%' : null : null
                    },
                    styles[getResponsiveStyle('newTopNavImage2Mainview', measure)]
                  ]}
                >
                  <View>
                    <Text
                      style={[
                        styles.TopnavMobileIPText,
                        styles[getResponsiveStyle('TopnavMobileIPText', measure)]
                      ]}
                    >
                      IP: {props.userIp}
                    </Text>
                  </View>
                  <View style={{ marginTop: 5 }}>
                    <Text
                      style={[
                        styles.TopnavMobileIPText,
                        styles[getResponsiveStyle('TopnavMobileIPText', measure)]
                      ]}
                    >
                      Location: {props.userAddress}
                    </Text>
                  </View>
                </View>
              </View>
              : <View
                style={[
                  styles.TopnavMobileIPLOCATIONdettopnavmobHeader,
                  styles[
                  getResponsiveStyle('TopnavMobileIPLOCATIONdettopnavmobHeader', measure)
                  ]
                ]}
              >
                <View
                  style={[
                    styles.newTopNavImage2MainviewLocation,
                    {
                      marginLeft: props.Dontshow_Searchoption ? props.Dontshow_Searchoption ? '55%' : null : null
                    },
                    styles[getResponsiveStyle('newTopNavImage2MainviewLocation', measure)]
                  ]}
                >

                  <View style={{ marginTop: 5 }}>
                    <Text
                      style={[
                        styles.TopnavMobileIPText,
                        styles[getResponsiveStyle('TopnavMobileIPText', measure)]
                      ]}
                    >
                      Location: {props.userAddress}
                    </Text>
                  </View>
                </View>
              </View>
            : null}
          <View
            style={[
              styles.newTopNavbarupdatescreens,
              { backgroundImage: 'linear-gradient(to bottom, #f58e21, #ef6812)' },
              styles[getResponsiveStyle('newTopNavbarupdatescreens', measure)]
            ]}
          ></View>
        </View></View>) : (<View></View>)
      ) : (
        <View>
          {headerFlag ? (<View>
            <TopnavCommon
              {...this.props}
              isSearch={isSearch}
              navigation={props.navigation}
              showip={showip}
              //blur={blur}
              blur={data => handlePick(data)}
              Dontshow_Searchoption={window.location.pathname.includes(ALL_CONSTANTS.DUE_PATH) || noSearch ? true : false}
              textInputChange={this.textInputChange}
              CloseSelectionDropdown={props.CloseSelectionDropdown}
              SelectedDropdownOption={props.SelectedDropdownOption}
              SearchElements={props.SearchElements}
              searchOptionChange={this.searchOptionChange}
              ServiceRequests={props.ServiceRequests}
              OnServiceRequestsButtonPress={this.OnServiceRequestsButtonPress}
              valueBlur={props.valueBlur}
            />
          </View>) : null}
        </View>


      )}

      {children}
    </View>
  );
};

export default Header;